import { Box, Slider, Button, Stack, IconButton } from "@mui/material";
import { Cancel } from "@mui/icons-material";
import Loading from "Components/Loading/Loading";

interface ISlidersSetupProps extends React.HTMLAttributes<HTMLDivElement> {
  sliderValues: number[];
  setSliderValues: React.Dispatch<React.SetStateAction<number[]>>;
}

function SlidersSetup({
  sliderValues,
  setSliderValues,
  children,
}: ISlidersSetupProps) {
  const handleSliderChange = (index) => (event, newValue) => {
    setSliderValues((prevValues) => {
      const newValues = [...prevValues];
      newValues[index] = newValue;
      return newValues;
    });
  };

  const addSlider = () => {
    setSliderValues((prevValues) => [...prevValues, 50]);
  };

  const removeSlider = (index) => {
    setSliderValues((prevValues) => prevValues.filter((_, i) => i !== index));
  };

  return (
    <Stack direction={"row"} spacing={2} p={2}>
      {sliderValues.length === 0 ? (
        <Box sx={{ minHeight: 250, minWidth: 400 }}>
          <Loading />
        </Box>
      ) : (
        <>
          {sliderValues.map((value, index) => (
            <Stack
              key={index}
              justifyContent="space-between"
              alignItems={"center"}
            >
              <Slider
                orientation="vertical"
                value={value}
                min={0}
                max={100}
                onChange={handleSliderChange(index)}
              />
              <Box sx={{ mt: 1 }}>{value}</Box>

              <IconButton
                disabled={sliderValues.length <= 1}
                onClick={() => removeSlider(index)}
                sx={{ pb: 0 }}
              >
                <Cancel />
              </IconButton>
            </Stack>
          ))}
          {sliderValues.length < 10 && (
            <Box display={"flex"} alignItems="flex-end">
              <Button
                disabled={sliderValues.length >= 10}
                variant="contained"
                size="extraSmall"
                onClick={addSlider}
              >
                Add Slider
              </Button>
            </Box>
          )}
          <Box pl={2} sx={{ maxWidth: 330 }}>
            {children}
          </Box>
        </>
      )}
    </Stack>
  );
}

export default SlidersSetup;
